{
       "query-comment-columns": [
        {
            "display": "true",
            "ui_columnname": "Comment",
            "db_columnname": "comment",
            "datatype": "String",
            "mappingkey": "comment",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "Failure Description",
            "db_columnname": "failureDescription",
            "datatype": "String",
            "mappingkey": "failureDescription",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "ReportDate",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FirmROEID",
            "db_columnname": "firmROEID",
            "datatype": "String",
            "mappingkey": "firmROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Created By",
            "db_columnname": "createdBy",
            "datatype": "String",
            "mappingkey": "createdBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ],
    "quick-Search-Filter":[
        {
            "label": "Type", "columnname": "type", "placeholder": "Type",
            "width": "",  "datatype": "skip", "isLarge": false
        },
        {
            "label": "Symbol", "columnname": "symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "OrderID", "columnname": "orderID", "placeholder": "OrderID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Routed OrderID", "columnname": "routedOrderID", "placeholder": "Routed OrderID",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "TradeID", "columnname": "tradeId", "placeholder": "Trade ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Destination", "columnname": "destination", "placeholder": "Destination",
            "width": "", "datatype": "String", "isLarge": false
        },
         {
            "label": "GroupName", "columnname": "groupName", "placeholder": "GroupName",
            "width": "", "datatype": "String", "isLarge": false
        }
        
    ],
    "GridColumns":[
    {
        "display": "true",
        "ui_columnname": "Action",
        "db_columnname": "modifiedFlag",
        "datatype": "char",
        "mappingkey": "modifiedFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": false,
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Group Name",
        "db_columnname": "groupName",
        "datatype": "String",
        "mappingkey": "groupName",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "FirmROEID",
        "db_columnname": "firmROEID",
        "datatype": "String",
        "mappingkey": "firmROEID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Type",
        "db_columnname": "type",
        "datatype": "Skip",
        "mappingkey": "type",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Symbol",
        "db_columnname": "symbol",
        "datatype": "String",
        "mappingkey": "symbol",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "OrderID",
        "db_columnname": "orderID",
        "datatype": "String",
        "mappingkey": "orderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Routed OrderID",
        "db_columnname": "routedOrderID",
        "datatype": "String",
        "mappingkey": "routedOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trade ID",
        "db_columnname": "tradeId",
        "datatype": "String",
        "mappingkey": "tradeId",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Destination",
        "db_columnname": "destination",
        "datatype": "String",
        "mappingkey": "destination",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Failure Code",
        "db_columnname": "failureCode",
        "datatype": "String",
        "mappingkey": "failureCode",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Failure Description",
        "db_columnname": "failureDescription",
        "datatype": "String",
        "mappingkey": "failureDescription",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Actual Value",
        "db_columnname": "actualValue",
        "datatype": "String",
        "mappingkey": "actualValue",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Reference Value",
        "db_columnname": "referenceValue",
        "datatype": "String",
        "mappingkey": "referenceValue",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Status",
        "db_columnname": "status",
        "datatype": "String",
        "mappingkey": "status",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Exception Details",
        "db_columnname": "exceptionJSON",
        "datatype": "String",
        "mappingkey": "exceptionJSON",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Create Date",
        "db_columnname": "createDate",
        "datatype": "String",
        "mappingkey": "createDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Last Update",
        "db_columnname": "lastUpdate",
        "datatype": "String",
        "mappingkey": "lastUpdate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Last User",
        "db_columnname": "lastUser",
        "datatype": "String",
        "mappingkey": "lastUser",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    }
]
}